import BaseReportPDFGenerator from "../../reports/BaseReportPDFGenerator"
import PDFDefinitionCreator from "./PDFDefinitionCreator"
import {DateFormat} from "../../date_format"
import PDFParametersFormattingStrategy from "./PDFParametersFormattingStrategy"

export default class PDFGenerator extends BaseReportPDFGenerator {
    init(store, generalStore, productSettingsValidator, reportRightsValidator) {
        super.init(store, generalStore, productSettingsValidator, reportRightsValidator);

        this.docDefinitionCreator = new PDFDefinitionCreator();
        this.generalStore = generalStore;

        return this;
    }

    _getParametersFormattingStrategy(config) {
        const dateFormatForFileName = new DateFormat('yyyy-MM-dd')
        return new PDFParametersFormattingStrategy().init({
            users: this.generalStore.getVisibleUsers(),
            userGroups: this.generalStore.getUserGroups(),
            timeZoneGroups: this.generalStore.getTimeZoneGroups(),
            dateFormat: config.dateFormat,
            dateFormatForFile: dateFormatForFileName,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/overtimeReport/PDFGenerator.js